import { page as PagesNotFound } from "./pages/[...notFound].js";
import { page as PagesAnalytics } from "./pages/analytics.js";
import { page as PagesBlogArchiveIndex } from "./pages/blog/archive/index.js";
import { page as PagesBlogAuthorsId } from "./pages/blog/authors/[id].js";
import { page as PagesBlogCategoriesName } from "./pages/blog/categories/[name].js";
import { page as PagesBlogCategoriesIndex } from "./pages/blog/categories/index.js";
import { page as PagesBlogEvents } from "./pages/blog/events.js";
import { page as PagesBlogIndex } from "./pages/blog/index.js";
import { page as PagesBlogPostsSlug } from "./pages/blog/posts/[slug].js";
import { page as PagesBlogSearch } from "./pages/blog/search.js";
import { page as PagesIndex } from "./pages/index.js";
import { page as PagesPreviewToken } from "./pages/preview/[token].js";
import { page as PagesReviewer } from "./pages/reviewer.js";
import { page as PagesSubmit } from "./pages/submit.js";
import { layout as PagesLayout } from "./pages/layout.js";

export const routes = [
	{ path: "/*", element: PagesNotFound, auth: false },
	{ path: "/analytics", element: PagesAnalytics, auth: false },
	{ path: "/blog/archive", element: PagesBlogArchiveIndex, auth: false },
	{ path: "/blog/authors/:id", element: PagesBlogAuthorsId, auth: false },
	{ path: "/blog/categories/:name", element: PagesBlogCategoriesName, auth: false },
	{ path: "/blog/categories", element: PagesBlogCategoriesIndex, auth: false },
	{ path: "/blog/events", element: PagesBlogEvents, auth: false },
	{ path: "/blog", element: PagesBlogIndex, auth: false },
	{ path: "/blog/posts/:slug", element: PagesBlogPostsSlug, auth: false },
	{ path: "/blog/search", element: PagesBlogSearch, auth: false },
	{ path: "/", element: PagesIndex, auth: false },
	{ path: "/preview/:token", element: PagesPreviewToken, auth: false },
	{ path: "/reviewer", element: PagesReviewer, auth: false },
	{ path: "/submit", element: PagesSubmit, auth: false },
];

export const layouts = {
	"/": PagesLayout,
};
